import { render, staticRenderFns } from "./DictSelectDialog.vue?vue&type=template&id=8d78dfcc&"
import script from "./DictSelectDialog.vue?vue&type=script&lang=js&"
export * from "./DictSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./DictSelectDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports